import React from "react";
import { observer } from "mobx-react";
import { CreditAccountViewStore } from "../../store";
import { CreditAccountViewForm } from "./CreditAccountViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type CreditAccountViewProps = {
  creditAccountViewStore: CreditAccountViewStore;
};

export const CreditAccountView: React.FC<CreditAccountViewProps> = observer(
  ({ creditAccountViewStore }) => {
    return (
      <div>
        <CreditAccountViewForm
          balance={creditAccountViewStore.balanceValue}
          tierValue={creditAccountViewStore.tierValue}
          movementsVisibleColumns={
            creditAccountViewStore.movementsVisibleColumns
          }
          movementsSetColumnWiths={(x) =>
            creditAccountViewStore.movementsSetColumnWiths(x)
          }
          movementsRows={creditAccountViewStore.movementsRowsDyn}
          onPrint={(handlePrint: () => void) =>
            creditAccountViewStore.printCreditAccount(handlePrint)
          }
          onCancel={() => creditAccountViewStore.cancelCreditAccount()}
          onEdit={
            creditAccountViewStore.isEditEnabled
              ? () => creditAccountViewStore.editCreditAccount()
              : undefined
          }
        />
        <ErrorDialog
          open={creditAccountViewStore.errorDialogOpened}
          title={creditAccountViewStore.errorTitle}
          description={creditAccountViewStore.errorDescription}
          onClose={() => creditAccountViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
